import React, { useState } from 'react';
import LoginComponent from "../../components/master/LoginComponent";
import { pexios } from "../../utils/functions";
import { history } from "../../utils/variables";
import { setAccidentInfo, setRouterData } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import logo from '../../assets/images/logo.png'
import HeaderIcon from '../../assets/images/header-icon/login.png'

export default function LossesAccident() {

    const {location,routerData, user} = useSelector(store => store);
    const dispatch = useDispatch();

    const [step, setStep] = useState(1);

    function callAccident(data) {
        const { user_token } = data;
        // pexios('/api/request_new_accident', 'post', { ...location, user_token })
        //     .then(res => {
                // dispatch(setRouterData({id: res.data.id, type: 'accident'}));
                // history.push('/waiting');
        //     });
        dispatch(setRouterData({...routerData,culpritToken: user_token}));
        // history.push('/user-info?user=culprit');
        // dispatch(setAccidentInfo({user_type:'culprit',insurance_type : 'third'}))
        history.push('/plans');
    }

    return (
        <>
        <div className='title-image'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        <div className='content lossesAccident'>
            <div className='fullWidth'>
            
                {/* {
                    step === 2 &&
                    <p className='mb20'>
                        کد پیامک شده به تلفن همراه مقصر حادثه را وارد نمایید.
                    </p>
                } */}
                <LoginComponent
                    type='مقصر'
                    // lossesLogin
                    submitAccidentType={user.type}
                    getStep={(step) => setStep(step)}
                    getData={callAccident}
                />
            </div>
        </div>
        </>
    );

};
